import {
  Button,
  ButtonGroup,
  Card,
  CardBody,
  CardHeader,
  Flex,
  Heading,
  Icon,
  Stack,
  useColorMode,
  useDisclosure,
} from "@chakra-ui/react";
import { useQuery } from "@tanstack/react-query";
import { createColumnHelper } from "@tanstack/react-table";
import moment from "moment";
import { useState } from "react";
import { toast } from "react-hot-toast";
import { AiOutlineEye, AiOutlinePlusCircle } from "react-icons/ai";
import { MdDelete } from "react-icons/md";
import { Link } from "react-router-dom";
import Alert from "../../components/common/Alert";
import Error from "../../components/common/Error";
import Loading from "../../components/common/Loading";
import Datatable from "../../components/Datatable/Datatable";
import { IUserInput } from "../../context/ReportContext/ReportContext";
import useAxios from "../../hooks/useAxios";

const ChartData = () => {
  window.document.title = "SOUL BLUEPRINT ALIGNMENT - Users";
  const { colorMode } = useColorMode();
  const [id, setId] = useState<string>("");
  const { isOpen, onOpen, onClose } = useDisclosure();
  const axios = useAxios();

  const { data, isLoading, isError } = useQuery({
    queryKey: ["chart_data"],
    queryFn: () => axios.get("/api/chart-data").then((res) => res.data),
  });

  const sendModal = (id: string) => {
    setId(id);
    onOpen();
  };

  const columnHelper = createColumnHelper<IUserInput>();
  const columns = [
    columnHelper.accessor("uuid", {
      header: () => "S.N",
      cell: (info) => info.row.index + 1,
    }),
    columnHelper.accessor("username", {
      header: () => "USERNAME",
      cell: (info) => info.getValue(),
    }),
    columnHelper.accessor("createdAt", {
      header: () => "INSERTED DATE",
      cell: (info) => moment(info.getValue()).format("LL"),
    }),
    columnHelper.accessor("country", {
      header: () => "country",
      cell: (info) => info.getValue(),
    }),
    columnHelper.accessor("dateOfBirth", {
      header: () => "Date of Birth",
      cell: (info) => info.getValue(),
    }),

    columnHelper.display({
      header: "Actions",
      id: "actions",
      cell: (props) => (
        <ButtonGroup>
          <Button
            // onClick={() => viewModals(props?.row?.original?.uuid as string)}
            onClick={() => toast.success("Sorry for open!")}
            rounded="2xl"
            size="sm"
            fontSize="14px"
            colorScheme="green"
            leftIcon={<Icon mr={-1} as={AiOutlineEye} fontSize="16px" />}
          >
            Open
          </Button>
          <Button
            onClick={() => sendModal(props?.row?.original?.uuid as string)}
            rounded="2xl"
            size="sm"
            fontSize="14px"
            colorScheme="red"
            leftIcon={<Icon mr={-1} as={MdDelete} fontSize="16px" />}
          >
            Delete
          </Button>
        </ButtonGroup>
      ),
    }),
  ];

  if (isLoading) return <Loading />;
  if (isError) return <Error message="Server error!" />;
  return (
    <>
      <Alert
        isOpen={isOpen}
        onClose={onClose}
        message="Are you sure!🤚 to delete this Data"
        id={id}
        type="chart_data"
      />
      {/* <CustomModal isOpen={isOpen} onClose={onClose} id={id} type="chart" /> */}
      <Card
        bg={colorMode === "dark" ? "blackAlpha.300" : "white"}
        id="from accont card"
        rounded="10px"
        boxShadow="0px 4px 6px rgba(94, 73, 155, 0.04)"
      >
        <Flex
          as={CardHeader}
          align="center"
          justify="space-between"
          borderBottom="0.5px solid #BFBFBF"
        >
          <Heading fontWeight={500} fontSize="20px">
            User chart data
          </Heading>
          <Stack direction={"row"} spacing={4}>
            <Button
              as={Link}
              to="/dashboard"
              bg="primary.200"
              color="white"
              colorScheme="yellow"
              leftIcon={<Icon as={AiOutlinePlusCircle} />}
            >
              Go back
            </Button>
          </Stack>
        </Flex>

        <CardBody>
          <Datatable data={data} columns={columns} />
        </CardBody>
      </Card>
    </>
  );
};

export default ChartData;
